import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [msg, setMsg] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return setMsg({ err: true, text: "Passwords do not match" });
    try {
      await api.post("/auth/reset-password", { token: params.get("token"), password: pw });
      setMsg({ err: false, text: "Password updated. You can sign in now." });
    } catch (e2) {
      setMsg({ err: true, text: errMsg(e2) });
    }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-[#0B0F17] px-6">
      <form onSubmit={submit} className="w-full max-w-sm space-y-4" data-testid="reset-form">
        <h1 className="font-display text-2xl font-bold text-slate-100">Choose a new password</h1>
        <Input data-testid="reset-password-input" type="password" placeholder="New password (8+ characters)" minLength={8} required value={pw} onChange={(e) => setPw(e.target.value)} className="h-11 bg-slate-950" />
        <Input data-testid="reset-password-confirm-input" type="password" placeholder="Repeat new password" required value={pw2} onChange={(e) => setPw2(e.target.value)} className="h-11 bg-slate-950" />
        {msg && <div data-testid="reset-message" className={`text-sm ${msg.err ? "text-rose-400" : "text-emerald-400"}`}>{msg.text}</div>}
        <Button data-testid="reset-submit-button" className="h-11 w-full btn-gold">Update password</Button>
        <Link to="/login" data-testid="reset-back-link" className="block text-sm text-slate-400 hover:text-slate-200">Back to sign in</Link>
      </form>
    </div>
  );
}
